
import React, { useState, useEffect, useMemo } from "react";
import GeneralAuthentication from "../general/GeneralAuthentication";
import * as customTheme from "../theme";
import { makeStyles, ThemeProvider, createTheme } from "@material-ui/core/styles";
import { FormControlLabel, Typography, Box, Grid, InputAdornment, List, ListItem, ListItemText, IconButton, Paper, Container, Button, TextField, Checkbox, Badge, Switch, Avatar, Menu, MenuItem } from "@material-ui/core";
import translations from "../utils/translations";
import ActionMessageButton from "../general/ActionMessageButton";
import Autocomplete from "@material-ui/lab/Autocomplete";
import quoteyBot from "../logos/common/quotey-homepage-bot.svg";
import quoteyTextOld from "../logos/common/quotey-text.svg";
import quoteyText from "../logos/common/quotey-text2.png";
import homepageBackground from "../logos/common/homepage-background.png"
import { getVerticalList, loadverticals } from "../store/verticals";
import { useDispatch, useSelector } from "react-redux";
import { createProspectByCallingAPI, getProspectIdJustCreated } from "../store/operations";
import { 	getMyCustomers, getCustomersTable} from "../store/mycustomers";
import {  getGroupList } from "../store/myreminder";
import {Settings as SettingsIcon, Save as SaveIcon, AddCircleOutline as AddCircleOutlineIcon, NotificationImportantRounded as NotificationIcon, Search as SearchIcon  } from '@material-ui/icons';
import { useNavigate, useLocation } from "react-router-dom";
import {	getAutoreminderState, reminderModalSet, bugModalOpened, getQFuserMode } from "../store/components";
import { brokerLoggedOut, getBrokerInformation, updateBrokerLanguagePreference, verifyToken,fetchReminderCount,getUserRoles,getProvinces,getIsUserVerified, } from "../store/broker";
import { AddReminderPopUp, ReminderPopOver } from "./ReminderModal";
import {	updateUserLanguagePreference, updateLanguagePreference } from "../store/userManagement";
import { getProductList, loadProducts } from "../store/products";
import { loadBrokerageInsurers, getInsurersList } from "../store/insurers";
import Spinner from "react-bootstrap/Spinner";
import BugModal from "../bugreport/BugModal";
import { CLIENT } from "../store/businesslogic/hardwiredlogic";


const NavigationHeader = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElr, setAnchorElr] = useState(null);
  const open = Boolean(anchorEl);
  const [localLanguage, setLocalLanguage] = useState(() => {
    return localStorage.getItem('language') || sessionStorage.getItem('language') || 'en';
  });
	const theme = createTheme();
	const broker = useSelector(getBrokerInformation);
	// Get language based on authentication status
	// For authenticated users: use broker preference, fallback to localStorage
	// For non-authenticated users: use ONLY localStorage to avoid state conflicts
	const languagecode = (broker?.istokenvalid && broker.information?.languagepreference)
		? broker.information.languagepreference
		: localLanguage;

	// Listen for language changes from other components and sync state
	// FIXED: Removed localLanguage from dependencies to prevent infinite loop
	useEffect(() => {
		const handleLanguageChange = (e) => {
			setLocalLanguage(e.detail || 'en');
		};

		const handleStorageChange = (e) => {
			if (e.key === 'language') {
				console.log('localStorage changed:', e.newValue);
				setLocalLanguage(e.newValue || 'en');
			}
		};

		// Initial sync on mount only
		const currentLang = localStorage.getItem('language') || sessionStorage.getItem('language') || 'en';
		
		setLocalLanguage(currentLang);

		window.addEventListener('languageChanged', handleLanguageChange);
		window.addEventListener('storage', handleStorageChange);

		return () => {
			window.removeEventListener('languageChanged', handleLanguageChange);
			window.removeEventListener('storage', handleStorageChange);
		};
	}, []); // Empty dependency array - only run once on mount
  const [showAddReminder, setshowAddReminder] = useState(false);
  const qfusermode = useSelector(getQFuserMode);
  console.log("qfusermode: ", qfusermode);
  console.log("location: ", location)
  const isClient = qfusermode === CLIENT;
	const useStyles = makeStyles((theme) => ({
		menu: {
			'& .MuiPaper-root': {
				border: '2px solid #d3d3d3',
				borderRadius: '12px',
				boxShadow: '0 6px 16px rgba(0, 0, 0, 0.2)',
				background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
				minWidth: '220px',
				padding: '8px 0',
			},
		},
		menuItem: {
			padding: '14px 20px',
			fontSize: '1rem',
			fontWeight: 500,
			color: '#2c3e50',
			borderBottom: '1px solid #f0f0f0',
			'&:last-child': {
				borderBottom: 'none',
			},
			'&:hover': {
				backgroundColor: '#e3f2fd',
				color: '#1976d2',
				transform: 'scale(1.02)',
				transition: 'all 0.3s ease-in-out',
			},
		},
		avatar: {
			width: 50, // Larger size
			height: 50,
			cursor: 'pointer',
  	},
	}));
	const classes = useStyles();
	const navItems = [
		{ label: {'en':'Add new Prospect', 'fr':'Nouveau client'}, path: '/' },
		{ label: {'en':'My Clients', 'fr':'Mes clients'}, path: '/mycustomers' },
		{ label: {'en':'Dashboard', 'fr':'Tableau de bord'}, path: '/dashboard' },
		{ label: {'en':'Feedback', 'fr':'Commentaire'}, path: '/feedback' },
		{ label: {'en':'Help', 'fr':'Aide'}, path: '/howtoVideos' },
		{ label: {'en':'Language', 'fr':'Langue'}, path: null },
		{ label: {'en':'Reminders', 'fr':'Rappels'}, path: '/reminders' },
		{ label: {'en':'Settings', 'fr':'Paramètres'}, path: '/useradmin/user' },
    { label: {'en':'Admin', 'fr':'Admin'}, path: '/brokeradmin/home' },
		{ label: {'en':'Quotey Admin', 'fr':'Quotey Admin'}, path: '/quoteyadmin/home' },
		{ label: {'en':'Logout', 'fr':'Déconnection'}, path: '/logout' },
	];
  let ischs = location.pathname == "/chs";
  let brokerageImg = isClient && broker?.brokerageImg?.logo_s3?.Location
  let logoSrc = ischs && brokerageImg ? broker?.brokerageImg?.logo_s3?.Location : ischs ? null : (brokerageImg ? broker?.brokerageImg?.logo_s3?.Location : quoteyText);
  let logoStyle = brokerageImg ? {maxHeight: '13vh', maxWidth: '100%', objectFit:'contain', height:'auto', width: 'auto', cursor:'pointer'} : { objectFit: 'contain', scale: '1' , maxHeight:"12vh", display: ischs ? 'none': null, cursor:'pointer' }


  // useEffect(() => {
  //   dispatch(getGroupList());
  //   dispatch(getClientList());
  //   dispatch(getReminderCategoryList());
  // }, []);
  
  useEffect(() => {
    dispatch(getUserRoles());
    dispatch(verifyToken());
    dispatch(getProvinces());
    dispatch(getGroupList());
    // setLanguage(languagepreference);
  }, [dispatch]);

  useEffect(() => {
    console.log("STARTED");
    console.log("isClient ", isClient)
  }, [])
	
	const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNavigation = (path) => {
    if(path == '/logout'){
      dispatch(brokerLoggedOut())
      setTimeout(() => {
        navigate('/');
      }, 500);
    }
    else if(path == '/feedback'){
      dispatch(bugModalOpened());
    }
    else if(path){
			navigate(path);
		}
    handleMenuClose();
    //setAnchorEl(null);
  };

	const handleLangToggle = (event) => {
		const newLanguage = event.target.checked ? "fr" : "en";
		// Update local state immediately
		setLocalLanguage(newLanguage);

		// Always save to both localStorage and sessionStorage for persistence
		localStorage.setItem("language", newLanguage);
		sessionStorage.setItem("language", newLanguage);

		// Update Redux state (this works even without authentication)
		dispatch(updateUserLanguagePreference(newLanguage));

		// Only make API calls if user is authenticated
		if (broker?.information && broker.istokenvalid) {
			dispatch(updateBrokerLanguagePreference(newLanguage));

			// Update language preference in the store via API
			const langSelected = {
				label: newLanguage === "fr" ? "French" : "English",
				value: newLanguage,
			};

			dispatch(
				updateLanguagePreference({
					id: broker.information.user._id,
					languagePreference: langSelected,
				})
			);
		} 

		// Dispatch custom event for other components to listen to
		window.dispatchEvent(new CustomEvent('languageChanged', { detail: newLanguage }));
	};

	return (
		<ThemeProvider theme={theme}>
    <div className="Header" style={{ display: 'flex', justifyContent: 'space-between', padding: '2vh 8vw 10px 10px', maxHeight:'12vh', alignItems:"center" }}>
			{logoSrc ? (
        
				<img src={logoSrc} className="quotey-bot" alt="quoteyrobo" style={logoStyle} onClick={() => { if(!isClient) navigate('/') }} />
			) : (
				<div></div>
			)}
      {
        ischs ?
          <>
          <div>
            <Switch checked={languagecode == 'fr'} onChange={handleLangToggle}/> ({languagecode.toUpperCase()})
          </div>
          </>
        : broker?.istokenvalid ?
          <Badge
            badgeContent={broker.information?.unViewedReminderCount} // Number of notifications
            color="error" // Red badge
            overlap="circular"
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
          }}
          >
            <Avatar className={classes.avatar} alt={broker?.information?.firstname + " " + broker?.information?.lastname} src={broker?.information?.image} onClick={handleAvatarClick} style={{ cursor: 'pointer' }}/>
          </Badge>
        :
          // Fallback language toggle for non-authenticated users
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 12px',
              backgroundColor: 'rgba(0, 123, 255, 0.1)',
              borderRadius: '20px',
              border: '2px solid rgba(0, 123, 255, 0.3)',
              position: 'relative',
              zIndex: 1000,
              pointerEvents: 'auto',
              minWidth: '120px',
              justifyContent: 'center'
            }}
          >
            <span style={{
              fontSize: '14px',
              color: languagecode === 'en' ? '#007bff' : '#666',
              fontWeight: languagecode === 'en' ? '600' : '500',
              userSelect: 'none'
            }}>EN</span>
            <Switch
              checked={languagecode === 'fr'}
              onChange={(e) => {
                console.log('Switch onChange called', e.target.checked);
                e.stopPropagation(); // Prevent event bubbling
                handleLangToggle(e);
              }}
              color="primary"
              size="small"
              style={{
                pointerEvents: 'auto',
                zIndex: 1001
              }}
            />
            <span style={{
              fontSize: '14px',
              color: languagecode === 'fr' ? '#007bff' : '#666',
              fontWeight: languagecode === 'fr' ? '600' : '500',
              userSelect: 'none'
            }}>FR</span>
          </div>
      }
			<Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
				className={classes.menu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
				PaperProps={{
          style: {
            marginTop: '4vh', // Adds spacing below the avatar
          },
        }}
      >
        {navItems.map((item) => (
          <RenderNavItem
            item={item} 
            handleLangToggle={handleLangToggle}
            languagecode={languagecode}
            classes={classes}
            anchorElr={anchorElr}
            setAnchorElr={setAnchorElr}
            handleMenuClose={handleMenuClose}
            handleNavigation={handleNavigation}
          />
        ))}
      </Menu>
      <ReminderPopOver
        id="add-reminder-icon"
        setAnchorEl={setAnchorEl}
        anchorEl={anchorEl}
        setshowAddReminder={setshowAddReminder}
        showAddReminder={showAddReminder}
      />
		</div>
    <BugModal/>
		</ThemeProvider>
	)
}

const ReminderNavView = ({anchorEl, setAnchorEl, handleMenuClose}) => {
  
  const dispatch = useDispatch();
  const broker = useSelector(getBrokerInformation);
  return (
    <div className="nav-notification">		
      <>
        <div style={{ position: "relative", paddingRight: "1em" }}>
          <Badge
            badgeContent={broker.information?.unViewedReminderCount} // Number of notifications
            color="error" // Red badge
            overlap="circular"
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <NotificationIcon style={{ fontSize: "1.3rem" }} />
          </Badge>
        </div>

        <AddCircleOutlineIcon
          // ref={buttonRef}
          onClick={(e) => {
            e.stopPropagation();
            //handleMenuClose();
            //setAnchorEl(e.currentTarget);
            //setshowAddReminder(true)

            dispatch(reminderModalSet(true));
          }}
        />
      </>
    </div>
  )
}

const RenderNavItem = ({item, handleLangToggle, languagecode, classes, anchorElr,setAnchorElr, handleMenuClose, handleNavigation}) => {
  const broker = useSelector(getBrokerInformation);
  let display = null;
  // console.log(broker)
  if(!broker.istokenvalid){
    display = 'none';
  }
  else if(item.label.en == 'Admin' && !broker.isadmin){
    display = 'none';
  }
  else if(item.label.en == 'Quotey Admin' && !broker.issuperadmin){
    display = 'none';
  }
  else if(item.label.en == 'Help' && languagecode === 'fr'){
    display = 'none';
  }
  return (
    <MenuItem
      key={item.label}
      onClick={() => handleNavigation(item.path)}
      className={classes.menuItem}
      style={{display}}
    >
      {item.label[languagecode]} 
      {item.label.en == 'Reminders' &&  <ReminderNavView anchorEl={anchorElr} setAnchorEl={setAnchorElr} handleMenuClose={handleMenuClose} /> }
      {item.label.en == 'Language' &&  <><Switch checked={languagecode == 'fr'} onChange={handleLangToggle}/> ({languagecode.toUpperCase()}) </> }
    </MenuItem>
  )
}

export default NavigationHeader;